"use strict";

module.exports = function periodicRate(nper, pmt, pv, fv, type, guess) {

	fv =  0;
	type = 0;
	guess = 0.1;

	nper = parseInt(nper);
	pmt = parseFloat(pmt);
	pv = parseFloat(pv);
	if (pmt > 0) pmt = 0 - pmt;

	if (nper < 1) throw new Error("Months in loan required");
	if (! pmt) throw new Error("Payment amt required");
	if (pv < 1) throw new Error("Current balance required");

	var lowLimit = 0;
	var highLimit = 1;
	var tolerance = Math.abs(0.00000005 * pmt);

	for (var i = 0; i < 100; i++) {
		var balance = pv;

		for (var j = 0; j < nper; j++ ) {
			if (type == 0) balance = balance * (1 + guess) + pmt;
			else balance = (balance + pmt) * (1 + guess);
		}

		if (Math.abs(balance + fv) < tolerance)  return guess;
		else if (balance + fv > 0) highLimit = guess;
		else lowLimit = guess;
	
		guess = (highLimit + lowLimit) / 2;
	}

	throw new Error("Rate calculation failed");
	
};